import { c as _c } from "react/compiler-runtime";
import type { VaultFormData } from '@onefootprint/core';
import type { CustomRequirementNumberFormat, Iso4217CurrencyCode, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import type { Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type NumberInputProps = {
  name: string;
  label: string;
  requiredRules: {
    required?: string;
  };
  format?: CustomRequirementNumberFormat;
  min?: number;
  max?: number;
  placeholder?: string;
  locale?: Locale;
};
export const NumberInput = t0 => {
  const $ = _c(31);
  const {
    name,
    label,
    requiredRules,
    format,
    min,
    max,
    placeholder,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.pages.customDataForm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const isCurrency = format?.formatKind === "currency";
  const isPercentage = format?.formatKind === "percentage";
  const minValue = min ?? (isPercentage ? 0 : undefined);
  const maxValue = max ?? (isPercentage ? 100 : undefined);
  let t2;
  if ($[1] !== maxValue || $[2] !== minValue || $[3] !== t) {
    t2 = () => {
      if (typeof maxValue === "number" && typeof minValue === "number") {
        return t(_temp, {
          min: minValue,
          max: maxValue
        });
      }
      if (typeof maxValue === "number") {
        return t(_temp2, {
          max: maxValue
        });
      }
      if (typeof minValue === "number") {
        return t(_temp3, {
          min: minValue
        });
      }
    };
    $[1] = maxValue;
    $[2] = minValue;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getHint = t2;
  let t3;
  if ($[5] !== format || $[6] !== isPercentage) {
    t3 = () => {
      if (format?.formatKind === "currency") {
        return getCurrencySymbol(format.code);
      }
      if (isPercentage) {
        return "%";
      }
    };
    $[5] = format;
    $[6] = isPercentage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getAddon = t3;
  const t4 = name as Path<VaultFormData>;
  let t5;
  if ($[8] !== getHint) {
    t5 = getHint();
    $[8] = getHint;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== getAddon) {
    t6 = getAddon();
    $[10] = getAddon;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = isCurrency ? 2 : undefined;
  let t8;
  if ($[12] !== minValue || $[13] !== t) {
    t8 = minValue !== undefined ? {
      value: minValue,
      message: t(_temp4, {
        min: minValue
      })
    } : undefined;
    $[12] = minValue;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== maxValue || $[16] !== t) {
    t9 = maxValue !== undefined ? {
      value: maxValue,
      message: t(_temp5, {
        max: maxValue
      })
    } : undefined;
    $[15] = maxValue;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== requiredRules || $[19] !== t8 || $[20] !== t9) {
    t10 = {
      ...requiredRules,
      min: t8,
      max: t9
    };
    $[18] = requiredRules;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== label || $[23] !== locale || $[24] !== placeholder || $[25] !== t10 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t11 = <Form.Number name={t4} label={label} placeholder={placeholder} hint={t5} locale={locale} addon={t6} decimalPlaces={t7} rules={t10} />;
    $[22] = label;
    $[23] = locale;
    $[24] = placeholder;
    $[25] = t10;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
const getCurrencySymbol = (code: Iso4217CurrencyCode): string => {
  if (code === 'usd') {
    return '$';
  }
  return code satisfies never;
};
function _temp($) {
  return $.number.labelMinMax;
}
function _temp2($_0) {
  return $_0.number.labelMax;
}
function _temp3($_1) {
  return $_1.number.labelMin;
}
function _temp4($_2) {
  return $_2.number.min;
}
function _temp5($_3) {
  return $_3.number.max;
}